export default __webpack_public_path__ + "images/IR.4e01892.png";